import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListForRewardsModule } from '@shared/core/components/lists/listsTypes/forRewards';
import { ShortMessageModule } from '@shared/core/components/shortMessage';

import { LoyaltyForMemberRewardsComponent } from './loyalty-for-member-rewards.shared.component';

@NgModule({
    declarations: [
        LoyaltyForMemberRewardsComponent
    ],
    imports: [
        CommonModule,
        ListForRewardsModule,
        ShortMessageModule,
    ],
    exports: [
        LoyaltyForMemberRewardsComponent
    ],
    providers: [],
})
export class LoyaltyForMemberRewardsModule { }
